// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttendanceStatusDTO  {
    _originalTypeClassName = "Loom.BO.AttendanceStatusDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttendanceStatusDTO.translate = translateService;
}
this.WorkFromHome = [];
this.WorkFromOffice = [];
this.AttendanceStatusDTOKey = null;
this._key = this.AttendanceStatusDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
WorkFromHome:any;
WorkFromOffice:any;
private _AttendanceStatusDTOKey:any;
get AttendanceStatusDTOKey(): any {
    return this._AttendanceStatusDTOKey;
  }
set AttendanceStatusDTOKey(value: any) {
    this._AttendanceStatusDTOKey = value;
    this._key = value;
  }
static setWorkFromHome = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkFromHome == null) $this.WorkFromHome = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkFromHome.length > 0) {
                    Domain.AttendanceStatusDTO.removeWorkFromHome($this, $this.WorkFromHome[0]);
                }

                Domain.AttendanceStatusDTO.addManyWorkFromHome($this, copyItems);
            }
static addManyWorkFromHome = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AttendanceStatusDTO.addWorkFromHome($this, items[i]);
                }
            }
static addWorkFromHome = ($this, item) => {
                if ($this.WorkFromHome == null) $this.WorkFromHome = [];
                if (item == null || $this.WorkFromHome.indexOf(item) > -1) return;
                $this.WorkFromHome.push(item);
}
static addRangeWorkFromHome = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AttendanceStatusDTO.addWorkFromHome($this, item));
            }
static removeWorkFromHome = ($this, item) => {
                if ($this == null || $this.WorkFromHome == null || $this.WorkFromHome.indexOf(item) === -1) return;
                var _index = $this.WorkFromHome.indexOf(item);
                $this.WorkFromHome.splice(_index, 1);
}
static clearWorkFromHome = ($this) => { $this.WorkFromHome = null; }
static setWorkFromOffice = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkFromOffice == null) $this.WorkFromOffice = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkFromOffice.length > 0) {
                    Domain.AttendanceStatusDTO.removeWorkFromOffice($this, $this.WorkFromOffice[0]);
                }

                Domain.AttendanceStatusDTO.addManyWorkFromOffice($this, copyItems);
            }
static addManyWorkFromOffice = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AttendanceStatusDTO.addWorkFromOffice($this, items[i]);
                }
            }
static addWorkFromOffice = ($this, item) => {
                if ($this.WorkFromOffice == null) $this.WorkFromOffice = [];
                if (item == null || $this.WorkFromOffice.indexOf(item) > -1) return;
                $this.WorkFromOffice.push(item);
}
static addRangeWorkFromOffice = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AttendanceStatusDTO.addWorkFromOffice($this, item));
            }
static removeWorkFromOffice = ($this, item) => {
                if ($this == null || $this.WorkFromOffice == null || $this.WorkFromOffice.indexOf(item) === -1) return;
                var _index = $this.WorkFromOffice.indexOf(item);
                $this.WorkFromOffice.splice(_index, 1);
}
static clearWorkFromOffice = ($this) => { $this.WorkFromOffice = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AttendanceStatusDTOKey == null || $this.AttendanceStatusDTOKey == 0;
            }


}